var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React from "react";
import { showAlert } from "../utils/alert/alert.utils";
import apiUtils from "../utils/api/api.utils";
import { getItem, setItem } from "../utils/asyncStorage.utils";
var CACHE_KEY_PREFIX = "inline_cache";
export var useGetInline = function (params) {
    var path = params.path, cacheType = params.cacheType, cacheKey = params.cacheKey;
    // State
    var _a = React.useState(false), isFetching = _a[0], setIsFetching = _a[1];
    var _b = React.useState(undefined), fetchError = _b[0], setFetchError = _b[1];
    var _c = React.useState(), data = _c[0], setData = _c[1];
    var parsedCacheKey = "".concat(CACHE_KEY_PREFIX, ":").concat(cacheKey || path);
    // Data
    var fetchData = function () {
        var args_1 = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args_1[_i] = arguments[_i];
        }
        return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (useCache) {
            var cachedData, response, error_1, unknownError_1, error;
            if (useCache === void 0) { useCache = true; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!path) {
                            return [2 /*return*/];
                        }
                        if (isFetching) {
                            return [2 /*return*/];
                        }
                        if (!(useCache && cacheType === "asyncStorageJson")) return [3 /*break*/, 2];
                        return [4 /*yield*/, getItem(parsedCacheKey)];
                    case 1:
                        cachedData = _a.sent();
                        if (cachedData) {
                            setData(JSON.parse("".concat(cachedData)));
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 8, , 9]);
                        setIsFetching(true);
                        setFetchError(undefined);
                        return [4 /*yield*/, apiUtils.get(path)];
                    case 3:
                        response = _a.sent();
                        setIsFetching(false);
                        setData(response.data);
                        if (!(cacheType === "asyncStorageJson")) return [3 /*break*/, 7];
                        _a.label = 4;
                    case 4:
                        _a.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, setItem(parsedCacheKey, JSON.stringify(response.data))];
                    case 5:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 6:
                        error_1 = _a.sent();
                        return [3 /*break*/, 7];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        unknownError_1 = _a.sent();
                        error = unknownError_1;
                        setIsFetching(false);
                        setFetchError(error);
                        showAlert({
                            type: "error",
                            error: error,
                        });
                        return [3 /*break*/, 9];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    // Lifecycle methods
    React.useEffect(function () {
        // Reset data if path changes
        setIsFetching(false);
        setFetchError(undefined);
        setData(undefined);
        fetchData();
    }, [path, cacheType, cacheKey]);
    return {
        data: data,
        isFetching: isFetching,
        fetchError: fetchError,
        fetchData: fetchData,
    };
};
